import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import store from '@state/store'
let serverUrl = getSecret('SERVER_URL')


export const state = {
  //   cached: {},
}

export const getters = {}

export const mutations = {
  //   CACHE_USER(state, users) {
  //     state.cached = users
  //   },
}

export const actions = {
  
  init({ state, dispatch }) { },
  
  fetchCompaniesList(context) {
    return axios.get(`${serverUrl}/app/companies/list`)
  },
  
  fetchStores(context, data) {
    return axios.get(`${serverUrl}/app/stores/?company_id=${data.company_id}`)
  },

  createUpdateStore(context, data){
    return axios.post(`${serverUrl}/app/stores/`, data)
  },
  
  fetchAccessPointsByStore(context, data) {
    let query = data.store_id ? `?store_id=${data.store_id}` : ''
    return axios.get(`${serverUrl}/app/access_point/${query}`)
  },
  
  fetchTemplate(context, data) {
    const { ref, templateId } = data;
    return axios.get(`${serverUrl}/templates/${(ref)}/${templateId}.json`)
  },
  
  fetchTemplates(context){
    return axios.get(`${serverUrl}/app/templates/`)
  },

  flashingLED(context, data){
    return axios.post(`${serverUrl}/broker/labels/flash/`, data)
  },
  
  powerOFFScreen(context, data){
    return axios.post(`${serverUrl}/broker/labels/power_off/`, data)
  },

  taskTemplate(context, data){
    const { labelId, templateId, fabricant } = data
    return axios.post(`${serverUrl}/broker/labels/task_template/${fabricant}`, data)
  },

  updateLabelSetTemplate(context, data){
    const { labelId, templateId } = data
    return axios.patch(`${serverUrl}/app/labels/${labelId}/template`, { template: templateId })
  },

  updateLabelSetItem(context, data){
    const { labelId, itemId } = data
    return axios.put(`${serverUrl}/app/labels/${labelId}`, { item_id: itemId })
  },

  updateTemplateCode(context, data){
    const { reference, template, JSON } = data
    return axios.post(`${serverUrl}/app/templates/update-file/${reference}/${template}`, JSON)
  },

  
  fetchReferences(context){
    return axios.get(`${serverUrl}/app/references/`)
  },

  fetchLabels(context, data){
    let query = data.store_id ? `?store_id=${data.store_id}` : ''
    return axios.get(`${serverUrl}/app/labels/${query}`)
  },

  fetchItems(context, data){
    let query = data.store_id ? `?store_id=${data.store_id}` : ''
    return axios.get(`${serverUrl}/app/items/with-labels/${query}`)
  },
  
  getInformation(context, data){
    return axios.post(`${serverUrl}/broker/labels/information/`, data)
  },

  getInformationDetail(context, data){
    return axios.post(`${serverUrl}/broker/labels/information/detail/`, data)
  },
  
  subscribeSSE(context, data ){
    const { companyId, handleMessage, handleError } = data;
    const sseClient = new EventSource(`${serverUrl}/broker/sse/${companyId}?t=${store.state.auth.currentSession.key}`)
    sseClient.addEventListener('message', event => {
      const messageData = JSON.parse(event.data);
      handleMessage(messageData);
    });
    sseClient.addEventListener('error', errorEvent => {
      handleError(errorEvent);
    });
    return sseClient;
  },

  /* COMPANIES: */
  createUpdateCompany(context, data) {
    if (data._id){
      let companyId = data._id
      return axios.put(`${serverUrl}/app/companies/${companyId}`, data)
    }
    return axios.post(`${serverUrl}/app/companies/`, data)
  },

  /* ACCESS_POINT */
  createUpdateAccessPoint(context, data) {
    return axios.post(`${serverUrl}/app/access_point/`, data)
  },

  /* LABELS */
  createUpdateLabel(context, data) {
    return axios.post(`${serverUrl}/app/labels/`, data)
  },

  /* ITEMS */
  createItem(context, data){
    return axios.post(`${serverUrl}/app/items/`, data)
  },
  createItemMassive(context, data){
    const { store_id, items } = data
    return axios.post(`${serverUrl}/app/items/${store_id}/massive`, items)
  },
  updateItem(context, data){
    return axios.put(`${serverUrl}/app/items/${data._id}`, data)
  }
}